import { SignIn } from "components"

export const Login = () => {
 return <SignIn />
}
